<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="tab">
            <div class="tab_wrap">
              <div class="t_txt" @click="changeTab(1)" :class="{ 'active': tabIndex === 1 }">기본정보</div>
              <div class="t_txt" @click="changeTab(2)" :class="{ 'active': tabIndex === 2 }">회원제품목록</div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="tab_content" v-if="tabIndex === 1">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100%" class="demo-ruleForm">
              <el-form-item label="휴대폰번호" prop="mb_hp">
                <el-input v-model="ruleForm.mb_hp" type="number" placeholder="휴대폰번호를 입력해주세요."></el-input>
              </el-form-item>
              <el-form-item label="타입" prop="mb_type">
                <el-radio-group v-model="ruleForm.mb_type" style="width:100%;">
                  <el-radio-button :label="1">일반회원</el-radio-button>
                  <el-radio-button :label="2">블랙회원</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="메모" prop="mb_memo">
                <el-input type="textarea" v-model="ruleForm.mb_memo" :rows="5" resize="none" placeholder="메모를 입력해주세요.">
                </el-input>
              </el-form-item>
              <el-form-item class="text-center">
                <el-button type="primary" @click="submitForm('ruleForm')">{{ mb_no ? '수정' : '등록' }}</el-button>
                <el-button @click="resetForm('ruleForm')">목록</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="tab_content" v-else-if="tabIndex === 2">
            <el-table :data="tableList" style="width: 100%" empty-text="데이터가 없습니다.">
              <el-table-column align="center" label="코드" prop="s_code">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].s_code }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="shot code" prop="s_code_short">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].s_code_short }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="라이센스" prop="pl_title">
                <template slot-scope="scope">
                  {{ scope.row.License[0].pl_title }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="타이틀" prop="s_title">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].s_title }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="링크" prop="s_shortLink">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].s_shortLink }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="유효기간" prop="s_is_guarantee_day">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].s_type == 1 ? scope.row.SafetyBell[0].LeftGuaranteeDay.days * -1 +
                    '일' : '-' }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="장소" prop="s_location">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].s_location }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="생성날짜" prop="created_at">
                <template slot-scope="scope">
                  {{ scope.row.SafetyBell[0].created_at }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuxAlert from '@/mixins/vux-alert';
import util from '@/mixins/util';
import axios from 'axios'
import validator from "@/mixins/validator";
import sessionStorage from '@/mixins/sessionStorage';
import { countryList } from "@/service/countryService";

export default {
  name: "MemberCreate",
  components: {},
  mixins: [VuxAlert, axios, validator, sessionStorage],
  data() {
    return {
      userInfo: this.getUserInfo(),
      mb_no: this.$route.params.mb_no,
      ruleForm: {
        c_idx: 1,
        mb_id: '',
        mb_name: '',
        mb_c_code: 82,
        mb_hp: '',
        mb_type: 1,
        mb_memo: '',
      },
      rules: {
        mb_hp: [
          { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
          { validator: this.validateNumber, trigger: 'blur' }
        ],
      },
      file: [],
      file_required: false,
      defaultInfo: {},
      tabIndex: 1,
      tableList: [],
      category: [],
    };
  },
  mounted() {
    this.getCountryList();
    this.getDetail();
    this.getMemberProduct();
  },

  methods: {
    initData() {
      this.ruleForm = {
        mb_c_code: this.mb_c_code,
        mb_hp: '',
        mb_type: 1,
        mb_memo: '',
        c_idx: this.c_idx,
      };
      this.mb_no = this.$route.params.mb_no;
    },

    changeTab(index) {
      if (this.tabIndex === index) {
        return false;
      }
      if (index === 1) {
        this.ruleForm = {
          mb_c_code: this.mb_c_code,
          mb_hp: this.defaultInfo.mb_hp,
          mb_type: Number(this.defaultInfo.mb_type),
          mb_memo: this.defaultInfo.mb_memo,
          c_idx: this.c_idx,
        }
      }
      this.tabIndex = index;
      this.getDetail();
    },
    getCountryList() {
      this.$api.$user.getCountry()
        .then(res => { // 로그인 api 통신 후 결과 처리
          //let resultData = res.Data.result;
          //this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
          this.category = countryList;
        });
    },
    getDetail() {
      if (this.mb_no) {
        this.initData();
        const params = { no: this.mb_no, m_type: 'normal' }
        this.$api.$user.getMemberList(params).then(res => res.Data.Result).then(res => {
          if (res.Info.Type === 1) {
            this.defaultInfo = res.List[0].Member;
            this.ruleForm = {
              mb_c_code: this.mb_c_code,
              mb_hp: this.defaultInfo.mb_hp,
              mb_type: Number(this.defaultInfo.mb_type),
              mb_memo: this.defaultInfo.mb_memo,
              c_idx: this.c_idx,
            }

          }
        })
      }
    },
    getMemberProduct() {
      if (this.mb_no) {
        let params = { mb_no: this.mb_no, ip: 1, type: 'basic' }
        this.$api.$product.getProductMemberList(params).then(res => res.Data.Result).then(res => {
          if (res.Info.Type === 1) {
            this.tableList = res.List;
            /*         util.each(this.tableData, (item, index, allItems) => {
                       item.pl_title = item.License[0].pl_title;
                       item.s_is_guarantee_day_reform = item.SafetyBell[0].LeftGuaranteeDay !== 0 ?  item.SafetyBell[0].LeftGuaranteeDay.days * -1 + '일' : '-';
                       item.has_member = item.hasOwnProperty('MemberInfo') && item.MemberInfo.mb_no ? '등록완료' : '미등록';
                       item.mb_id = item.hasOwnProperty('MemberInfo') && item.MemberInfo.mb_id ? item.MemberInfo.mb_id : '';
                     });*/
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          } else {
            this.tableData = [];
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          }

        })
      }
    },
    async submitForm(formName) {
      await this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            m_type: 'normal',
            mb_no: this.mb_no,
            mb_c_code: this.mb_c_code,
            mb_hp: this.ruleForm.mb_hp,
            mb_type: this.ruleForm.mb_type,
            mb_memo: this.ruleForm.mb_memo,
            c_idx: this.c_idx,
          }
          if (this.mb_no) {
            this.$api.$user.updateMember(params).then(res => res.Data.Result).then(res => {
              if (res.Info.Type === 1) {
                this.updateAlert({ getDetail: this.getDetail });
              } else {
                this.errorAlert(res.Info.reason);
              }
            })
          } else {
          }
        } else {
          this.validateAlert();
          return false;
        }
      });
    },

    resetForm(formName) {
      window.history.back();
    }
  }
}
</script>
